"use client";

import React from "react";

const SMSPrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-white dark:bg-boxdark text-black dark:text-white px-6 py-12">
      <h1 className="text-3xl font-bold mb-6">SMS Privacy Policy – LinqOps LLC</h1>
      <div className="max-w-3xl text-justify">
        <p className="mb-4">
          This SMS Privacy Policy ("Policy") describes how LinqOps LLC ("LinqOps," "we," "our," or "us") collects, uses, and discloses personal information in connection with our SMS messaging services. By opting in to receive SMS messages from LinqOps, you agree to the terms of this Policy.
        </p>

        <h2 className="text-xl font-semibold mb-2">Registration & Eligibility</h2>
        <p className="mb-4">
          To access certain features of our SMS services, you may be required to provide accurate, current, and complete information. Registration data and other information are governed by our Privacy Policy.
          If you are under 18 years of age, you are not authorized to use our SMS services.
        </p>

        <h2 className="text-xl font-semibold mb-2">Consent to Receive Messages</h2>
        <p className="mb-4">
          By enrolling in the Program, you expressly consent to receive recurring SMS from LinqOps LLC at the mobile number you provide, including messages sent using automated technology. Consent is not a condition of purchase. You represent that you are the owner or authorized user of the mobile number.
          {/* By providing your mobile number and opting in, you expressly consent to receive recurring SMS text messages from . Message frequency may vary. Standard message and data rates may apply depending on your mobile carrier. */}
        </p>
        <h3 className="text-lg font-medium mb-2">Types of SMS you may receive include:</h3>
        <ul className="list-disc list-inside mb-4">
          <li>Operational notices (e.g., schedules, routes, delivery status).</li>
          <li>Compliance or policy updates (e.g., write-ups, confirmations, reminders).</li>
          <li>Support or assistance responses to inbound messages you send.</li>
        </ul>
        <p className="mb-4">
          LinqOps does not use the Program for marketing purposes. LinqOps will not sell/share phone numbers obtained as part of the SMS consent process with third parties for their marketing purposes. We may use approved vendors (e.g., SMS gateways) solely to deliver/operate the Program, subject to contractual confidentiality limits.
        </p>
        <p className="mb-4 font-medium">
          Note: Message frequency may vary. Standard message and data rates may apply depending on your carrier and plan.
        </p>

        {/* Opt-in Methods */}
        <h2 className="text-xl font-semibold mb-2">Opt-In Methods</h2>
        <p className="mb-4">
          You may enroll in LinqOps SMS services through any of the following methods:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Checking the SMS consent box on our forms.</li>
          <li>Submitting an online form requesting SMS notifications.</li>
          <li>Providing documented verbal consent to LinqOps.</li>
          <li>Sending an inbound keyword (such as START/SUBSCRIBE) to our designated number.</li>
        </ul>

        <p className="mb-4">
          For compliance and audit purposes, we may retain a record of your consent, including the timestamp, source, and method of opt-in.
        </p>

        {/* Opt-out Methods */}
        <h2 className="text-xl font-semibold mb-2">Opt-Out Methods</h2>
        <p className="mb-4">
          You may unsubscribe from LinqOps SMS messages at any time by:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Replying STOP to any message you receive from us.</li>
          <li>Using recognized alternatives such as UNSUBSCRIBE.</li>
          <li>Requesting removal by contacting us at sales@linqops.com</li>
          <li>If you prefer not to receive SMS, simply leave the SMS consent box unchecked and avoid opting in through any of the methods mentioned above.</li>
        </ul>

        <p className="mb-4">
          Once we process your request, you will receive a one-time confirmation of your opt-out. After that, no further messages will be sent unless you choose to re-enroll. Please allow up to 72 hours for processing across all campaigns.
        </p>

        <p className="mb-4">
          If you wish to rejoin the program later, you may reply START to a previous thread (if available) or provide your consent again through one of the approved opt-in methods.
        </p>


        <h2 className="text-xl font-semibold mb-2">Inbound Message Handling</h2>
        <p className="mb-4">
          We support inbound messages to facilitate two-way communication. Examples include:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>HELP → We will respond with assistance or customer service details.</li>
          <li>STOP/UNSUBSCRIBE → We will process your opt-out.</li>
          <li>START/SUBSCRIBE → We will rejoin you to the program.</li>
        </ul>

        <p className="mb-4">
          All other inbound messages may receive a response or follow-up based on the content of the message.
        </p>

        {/* Information We Collect */}
        {/* <h2 className="text-xl font-semibold mb-2">Information We Collect</h2>
        <p className="mb-4">
          When you opt in to receive SMS messages from us, we may collect:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Your mobile phone number.</li>
        </ul>


        <h2 className="text-xl font-semibold mb-2">Information We Collect</h2>
        <p className="mb-4">
          When you opt in to receive SMS messages from us, we may collect:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Your mobile phone number.</li>
          <li>Information related to your communication preferences and interactions with our messaging services (e.g., message delivery, status, or engagement).</li>
          <li>Limited personal data necessary to provide and support SMS communications.</li>
        </ul>
        <p className="mb-4">
          We do not collect more information than is reasonably necessary to provide you with SMS services.
        </p> */}

        <h2 className="text-xl font-semibold mb-2">Use of Information</h2>
        <p className="mb-4">We may use your information to:</p>
        <ul className="list-disc list-inside mb-4">
          <li>Deliver requested SMS messages.</li>
          <li>Process inbound messages and provide appropriate responses.</li>
          <li>Maintain and support our SMS platform.</li>
          <li>Fulfill legal, regulatory, and carrier compliance requirements.</li>
        </ul>

        <h2 className="text-xl font-semibold mb-2">Disclosure of Information</h2>
        <p className="mb-4">
          LinqOps LLC may share your SMS-related information under the following circumstances:
        </p>
        <h3 className="text-lg font-medium mb-2">Service Providers and Messaging Partners</h3>
        <p className="mb-4">
          We may share your information with trusted third parties who help us operate or deliver SMS messages, including platform providers, mobile carriers, and vendors that assist with transmission, routing, or compliance. Opt-in consent data is only used for purposes directly related to providing the messaging service.
        </p>
        <h3 className="text-lg font-medium mb-2">Affiliates and Subsidiaries</h3>
        <p className="mb-4">
          We may disclose information to our affiliates or subsidiaries, provided they use and protect your information in accordance with this Policy.
        </p>
        <h3 className="text-lg font-medium mb-2">Legal Obligations and Protection of Rights</h3>
        <p className="mb-4">
          We may disclose information when required by law, regulation, legal process, or government request. We may also share information to protect the rights, property, or safety of LinqOps LLC, our customers, or others.
        </p>
        <p className="mb-4 font-medium">
          Important Note: All categories of disclosure described above exclude text messaging originator opt-in data and consent. This information will never be sold, rented, or shared with third parties for marketing purposes.
        </p>

        <h2 className="text-xl font-semibold mb-2">Data Security</h2>
        <p className="mb-4">
          We implement reasonable safeguards to protect your personal information in connection with our SMS services. However, no transmission of data over wireless or wired networks can be guaranteed to be 100% secure. Accordingly, you acknowledge that you provide your information at your own risk.
        </p>

        <h2 className="text-xl font-semibold mb-2">Retention of Information</h2>
        <p className="mb-4">
          We retain your personal information only for as long as necessary to fulfill the purposes described in this Policy, comply with legal obligations, resolve disputes, and enforce agreements.
        </p>

        <h2 className="text-xl font-semibold mb-2">Changes to This Policy</h2>
        <p className="mb-4">
          LinqOps LLC reserves the right to update or modify this SMS Privacy Policy at any time. Any changes will become effective when posted to our website or otherwise communicated to you. Your continued use of our SMS services constitutes acceptance of those changes.
        </p>

        <h2 className="text-xl font-semibold mb-2">Contact Information</h2>
        <p className="mb-4">
          If you have any questions about this SMS Privacy Policy or our data practices, please contact us at:
        </p>
        <p className="mb-4">
          LinqOps LLC<br />
          125 Roosevelt Dr, Wood Ridge, NJ 07075<br />
          Email: <a href="mailto:sales@linqops.com" className="text-primary">sales@linqops.com</a>
        </p>
        <hr className="my-6 border-gray-300 dark:border-gray-600" />
        <p className="mb-4">
          By opting in to and using our SMS services, you acknowledge that you have read, understood, and agree to the terms of this SMS Privacy Policy.
        </p>
      </div>
    </div>
  );
};

export default SMSPrivacyPolicy;